
const cryptoRandomString = require('crypto-random-string');
export default () => {
  const a = new Uint32Array(4) // we want 4 32bit values
  return Array.from(cryptoRandomString({length: 43, type: 'alphanumeric'}))
     .map(i => i.toString(16))
     .join('-')
}
